import { render, staticRenderFns } from "./TemplatePanelCreator.vue?vue&type=template&id=40e4a13c&scoped=true&"
import script from "./TemplatePanelCreator.vue?vue&type=script&lang=js&"
export * from "./TemplatePanelCreator.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePanelCreator.vue?vue&type=style&index=0&id=40e4a13c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e4a13c",
  null
  
)

export default component.exports